var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M14.005 0h-9.79A4.105 4.105 0 0 0 .108 4.105v9.79A4.105 4.105 0 0 0 4.214 18h9.79a4.105 4.105 0 0 0 4.105-4.105v-9.79A4.105 4.105 0 0 0 14.004 0m-7.81 14.531a.37.37 0 0 1-.369.39H4.183a.38.38 0 0 1-.37-.38V7.708a.37.37 0 0 1 .37-.38h1.643a.37.37 0 0 1 .37.38zm-1.221-8.64a1.355 1.355 0 0 1 .02-2.71 1.354 1.354 0 0 1-.02 2.708m9.985 8.631a.36.36 0 0 1-.349.358h-1.734a.36.36 0 0 1-.35-.359v-3.16c0-.472.145-2.053-1.251-2.053-1.088 0-1.303 1.108-1.345 1.601v3.684a.36.36 0 0 1-.349.36H7.898a.36.36 0 0 1-.359-.36V7.674a.36.36 0 0 1 .36-.348h1.682a.36.36 0 0 1 .36.348v.596a2.39 2.39 0 0 1 2.247-1.027c2.801 0 2.791 2.617 2.791 4.105z"
  })));
};
export default SvgLinkedin;